import { SubmissionError, change } from 'redux-form';
import fetch from '../../core/fetch';

import messages from '../../locale/messages';
import { getListingData } from '../../actions/getListing';
import { manageListingSteps } from '../../actions/manageListingSteps';
import { getListingFieldsValues } from '../../actions/getListingFieldsValues';
import { setLoaderStart, setLoaderComplete } from '../../actions/loader/loader';
import history from '../../core/history';
import { updateListing as query, createListing as createQuery } from '../../lib/graphql';
import { userRestriction } from '../../helpers/DemoRestriction/demoRestriction';
import showToaster from '../../helpers/showToaster';

async function update(values, dispatch) {

  let bedTypes, roomType, houseType, bedrooms, buildingSize, bedType, bathroomType;

  const isRestrict = await dispatch(userRestriction({ restrictType: 'listing', restrictValue: values?.id }));
  if (isRestrict) {
    showToaster({ messageId: 'demoWarning', toasterType: 'warning' });
    return;
  }

  bedTypes = JSON.stringify(values?.bedTypes);
  roomType = String(values?.roomType);
  houseType = String(values?.houseType);
  bedrooms = String(values?.bedrooms);
  buildingSize = String(values?.buildingSize);
  bedType = String(values?.bedType);
  bathroomType = String(values?.bathroomType);

  let variables = Object.assign({}, values, {
    bedTypes, roomType, houseType, bedType,
    bedrooms, buildingSize, bathroomType
  });

  dispatch(setLoaderStart('updateListing'));

  if (!values.id) {
    // Se llegó al paso del mapa sin crear el listing (ej. formulario manual
    // de Page5 que navega a "map" sin pasar por submit): crearlo primero con
    // los mismos valores para obtener el id y seguir con el update.
    const createResp = await fetch('/graphql', {
      method: 'post',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        query: createQuery,
        variables
      }),
      credentials: 'include'
    });

    const { data: createData } = await createResp.json();

    if (createData?.createListing?.status == "success" && createData?.createListing?.id) {
      values.id = createData.createListing.id;
      variables = Object.assign({}, variables, { id: values.id });
      dispatch(change('ListPlaceStep1', 'id', values.id));
    } else if (createData?.createListing?.status == "notLoggedIn") {
      dispatch(setLoaderComplete('updateListing'));
      throw new SubmissionError({ _error: messages.notLoggedIn });
    } else {
      dispatch(setLoaderComplete('updateListing'));
      throw new SubmissionError({ _error: messages.somethingWentWrong });
    }
  }

  const resp = await fetch('/graphql', {
    method: 'post',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      query: query,
      variables
    }),
    credentials: 'include'
  });

  const { data } = await resp.json();

  if (data?.updateListing?.status == "success") {
    await dispatch(manageListingSteps(values.id, 1));
    history.push('/become-a-host/' + values.id + '/home');
    await dispatch(getListingData(values.id));
    await dispatch(getListingFieldsValues("2", values.id));
    await dispatch(setLoaderComplete('updateListing'));
  } else if (data.updateListing.status == "notLoggedIn") {
    dispatch(setLoaderComplete('updateListing'));
    throw new SubmissionError({ _error: messages.notLoggedIn });
  } else {
    dispatch(setLoaderComplete('updateListing'));
    throw new SubmissionError({ _error: messages.somethingWentWrong });
  }

}

export default update;
